import { render, staticRenderFns } from "./dilu-picker.vue?vue&type=template&id=3f60f922&scoped=true&"
import script from "./dilu-picker.vue?vue&type=script&lang=js&"
export * from "./dilu-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f60f922",
  null
  
)

export default component.exports